export default "__VITE_ASSET__nCCvjVL___"